import React, { useState } from "react";
// 12 Jun 2025
import { useGetUserActionsQuery } from '@/features/userActions/userActionsApiSlice'
import { useGetTrailsQuery } from '@/features/trails/trailsApiSlice'

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon 
} from "@heroicons/react/24/solid"

import EtActionCard from '@/components/actions/EtActionCard'
import moment from "moment";




const EtTrinityReviewActions = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Display user's pending actions to help them clear backlog
  // Updated - 12 Jun 2025 - Added the main logic using EtActionCard

  // 1️⃣ Fetch Data
  const { data: userActionsData, refetch: refetchUserActions } = useGetUserActionsQuery();
  const { data: trailsData } = useGetTrailsQuery();

  // 2️⃣ Extract Data
  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const allActions = extractEntitiesFromAdapter(userActionsData);
  const allTrails = extractEntitiesFromAdapter(trailsData);

  // console.log('allActions', allActions)
  // console.log('allTrails', allTrails)

  // 3️⃣ Filter pending & overdue actions
  const pendingActions = allActions?.filter(action =>
    action?.userId?._id === userId &&
    action?.userActionProgress < 100 &&
    moment(action?.completeBy).isBefore(moment(), 'day')
  );

  // 4️⃣ Trail Filter
  const [selectedTrail, setSelectedTrail] = useState("all");
  const usedTrailNames = Array.from(new Set(pendingActions?.map(a => a?.trailId?.trailName)));

  const filteredActions = selectedTrail === "all"
    ? pendingActions
    : pendingActions?.filter(a => a?.trailId?.trailName === selectedTrail);

  return (
    <div className="p-4 w-full max-w-6xl mx-auto">
      <div className="flex justify-between items-center">
           <p className="text-lg font-bold text-gray-800 mb-2">Clear Your Action Backlog</p>
           {/* Close */}
          <button onClick={onClose} className="mx-2 px-2 mb-2 text-sm text-blue-600 underline">
            Close
          </button>
      </div>
    
      {/* Trail Filter */}
      <div className="m-1 p-1">
      <div className="my-2 py-2 flex justify-center items-center space-x-2 border-b border-t bg-orange-50">
        <div className="flex items-center">
          <ArrowTrendingUpIcon className="w-6 h-6 text-orange-600" />
          <p className="mx-1 px-1 text-lg font-bold text-orange-600">Trail:</p>
          <select
            value={selectedTrail}
            onChange={(e) => setSelectedTrail(e.target.value)}
            className="text-lg font-bold rounded border border-gray-300 px-2 py-1"
          >
            <option value="all">All Trails</option>
            {allTrails
              ?.filter(trail => usedTrailNames.includes(trail.trailName))
              ?.map(trail => (
                <option key={trail._id} value={trail.trailName}>
                  {trail.trailName}
                </option>
            ))}
          </select>
        </div>

        {/* Action Count Badge */}
        <div className="flex justify-center items-center">
          <span className="text-lg text-gray-700 mx-1 px-1">There are </span>
          <div className="w-8 h-8 rounded-full bg-orange-600 text-white flex justify-center items-center text-lg font-bold">
            {filteredActions?.length || 0}
          </div>
          <span className="text-lg text-gray-700 mx-1 px-1">actions past due! </span>
        </div>
      </div>
      </div>


      {/* Action List */}
      <div className="max-h-[400px] overflow-y-auto ">
        {filteredActions?.length > 0 ? (
          filteredActions
            ?.slice()
            ?.sort((a, b) => new Date(a.completeBy) - new Date(b.completeBy))
            ?.map((action, index) => (
              <EtActionCard
                key={action._id}
                action={action}
                actionIndex={index}
                refetchUserActions={refetchUserActions}
              />
            ))
        ) : (
          <p className="text-sm italic text-gray-500 mt-4">
            No pending actions found before today.
          </p>
        )}
      </div>

      
    </div>
  );
};

export default EtTrinityReviewActions;